import { useMutation, useQueryClient } from '@tanstack/react-query'
import { Toast } from 'ui/components/Toast'

import { handlerServerError } from '@orbit/errors'

import * as Service from '../../service'
import { CTR_LIST_WEBPAGE_KEY } from './useGetCTRList'

export const useDelete = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (ids: number[]) => Promise.all(ids.map((id) => Service.CTR.remove({ id }))),
    onError: (error) => handlerServerError(error),
    onSuccess: async () => {
      Toast.successSmall('The CTR successfully deleted')
      await queryClient.invalidateQueries({ queryKey: [CTR_LIST_WEBPAGE_KEY] })
    }
  })
}
